import React, { useEffect, useState } from "react";
import "../App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import { authenticationService } from "../services/AuthinticationService";
import SVGraphics from "../assets/SVGraphics";
import { SideNavigationBar } from "../components/navigation/SideNavigationBar";
import IdleTimer from "react-idle-timer";
import Tab from "../components/navigation/Tab";
import { VerificationCode } from "./auth/VerificationCode";
import { ForgotPassword } from "./auth/ForgotPassword";
import { Login } from "./auth/Login";
import { Register } from "./auth/Register";
import { ResetPassword } from "./auth/ResetPassword";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Config from "../config/Config";
import { navOptions } from "../config/NavigationConfig";
import { AdminApi, LoginAPICalls } from "../services/ApiService";
import GenesisBG from "../assets/GenesisBG.png";
import DashboardComp from "./app/DashboardComp";
import PatientListComp from "./app/PatientListComp";
import AdminManagementComp from "./app/AdminManagementComp";
import UserListComp from "./app/UserListComp";
import PatientComp from "./app/patient/PatientComp";
import SiteListComp from "./app/SiteListComp";
import DICOMViewer from "./app/FADicomViewer";
import RadiologistApi from "../services/ApiServices/RadiologistApi";
import ViewerLoader from "./app/ViewerLoader";
import FADicomViewer from "./app/FADicomViewer";
import formData from "../components/forms/formsData.json";
import PopUpWindow from "../components/popups/PopUpWindow";
import ViewerLayout from "../view/app/DicomViewerNew/ViewerLayout";

function MainRouters() {
  const [isIdle, setIsIdle] = useState(false);
  const autoLogoutTime = 12 * (30 * 60 * 1000); // TODO: move to env 
  const [anchorEl, setAnchorEl] = React.useState(null);

  const navigate = useNavigate();
  const [beVersion, setBeVersion] = useState("");
  const pathname = window.location.pathname;
  const shouldShowSideNav = !pathname.toLowerCase().includes("dicomviewer");
  const [isAccountOpen, setIsAccountOpen] = useState(false);

  // Listen for force logout events from API calls
  useEffect(() => {
    const handleForceLogout = (event) => {
      console.log("Force logout triggered:", event.detail);
      navigate('/login');
    };

    window.addEventListener('forceLogout', handleForceLogout);
    
    return () => {
      window.removeEventListener('forceLogout', handleForceLogout);
    };
  }, [navigate]);

  const handleOpenAccount = () => {
    document.body.style.overflow = "hidden";
    setIsAccountOpen(true);
  };

  const handleCloseAccount = () => {
    document.body.style.overflow = "auto";
    setIsAccountOpen(false);
  };

  // --- settings popup state + handlers ---
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const handleOpenSettings = () => {
    document.body.style.overflow = "hidden";
    setIsSettingsOpen(true);
  };
  const handleCloseSettings = () => {
    document.body.style.overflow = "auto";
    setIsSettingsOpen(false);
  };


  const currentUser = authenticationService.isLoggedin()
    ? authenticationService.currentUserValue.role
    : "";
  const bypassAuthRoutes =
    pathname === "/login" ||
    pathname === "/" ||
    pathname === "/verificationCode" ||
    pathname === "/forgotPassword" ||
    pathname === "/ResetPassword" ||
    pathname.includes("register/") ||
    pathname.startsWith("/open-access/viewer-loader") ||
    pathname.startsWith("/open-access/dicom-viewer");

  const isLoginRoutes =
    pathname === "/login" ||
    pathname === "/" ||
    pathname === "/verificationCode" ||
    pathname === "/forgotPassword" ||
    pathname === "/ResetPassword" ||
    pathname.includes("register/");
  useEffect(() => {
    if (!bypassAuthRoutes && !currentUser) {
      navigate("/login");
    }

    const currentUrl = window.location.href;
    let currentUserRole = currentUser ? currentUser : "";

    if (
      !currentUrl.includes(currentUserRole) &&
      !currentUrl.includes("register/")
    ) {
      navigate(`login`);
    }

    const getVersion = async () => {
      let BEVersion = await LoginAPICalls.getVersion();
      setBeVersion(BEVersion.data);
    };
    getVersion().then();
  }, []);

  const rolePath = currentUser ? currentUser : "";
  console.log("currentUser", currentUser);

  // helper – use this above addTab
const tabsForStorage = (tabs) =>
  tabs.map(({ dicomProps, ...rest }) => rest);


const addTab = (page, id, examId, dicomProps) => {
    const existingTabIndex = openTabs.findIndex(
      (tab) => tab.id === id && tab.page === page && tab.examId === examId
    );
  
  // --------------------------
  // EXISTING TAB
  // --------------------------
  if (existingTabIndex !== -1) {
    const existingTab = openTabs[existingTabIndex];
    let updatedTabs = openTabs;

    // If this is a case tab and now we have dicomProps, save them in memory
    if (dicomProps && page === "case" && !existingTab.dicomProps) {
      updatedTabs = openTabs.map((t, idx) =>
        idx === existingTabIndex ? { ...t, dicomProps } : t
      );
      setOpenTabs(updatedTabs);

      // save light version without dicomProps
      localStorage.setItem(
        "openTabs",
        JSON.stringify(tabsForStorage(updatedTabs))
      );
    }

    setActiveTabIndex(existingTabIndex);
    localStorage.setItem("activeTabIndex", existingTabIndex);

    navigateToPage(page, id, examId, dicomProps);

    return { isNew: false, tab: updatedTabs[existingTabIndex] };
  }

  // NEW TAB (only if dicomProps exist for case)
    // If we are opening a CASE tab, remove the PATIENT tab with the same id
  let baseTabs = openTabs;
  if (page === "case") {
    baseTabs = openTabs.filter(
      (tab) => !(tab.page === "patient" && tab.id === id)
    );
  }

    // If we are opening a PATIENT tab (from back button), remove the CASE tab with the same id
    if (page === "patient") {
      baseTabs = baseTabs.filter(
        (tab) => !(tab.page === "case" && tab.id === id)
      );
    }

  const newTab = { page, id, examId, dicomProps };
  const updatedTabs = [...baseTabs, newTab];
  const newIndex = updatedTabs.length - 1;

  setOpenTabs(updatedTabs);
  setActiveTabIndex(newIndex);

  localStorage.setItem(
    "openTabs",
    JSON.stringify(tabsForStorage(updatedTabs))
  );
  localStorage.setItem("activeTabIndex", newIndex);

  navigateToPage(page, id, examId, dicomProps);

  return { isNew: true, tab: newTab };
};



  const handleClosePopUp = () => {
    document.body.style.overflow = "auto";
    setIsSettingsOpen(false);
  };
  const removeTab = (tabToRemove) => {
    
    const { page, id } = tabToRemove;
    // Find the index of the tab to be removed
    const tabIndexToRemove = openTabs.findIndex(
      (tab) => tab.id === id && tab.page === page
    );

    if (tabIndexToRemove !== -1) {
      // Create a new array without the removed tab
      const updatedTabs = openTabs.filter(
        (_, index) => index !== tabIndexToRemove
      );
      setOpenTabs(updatedTabs);

      // Save cleaned version to localStorage
      localStorage.setItem(
        "openTabs",
        JSON.stringify(tabsForStorage(updatedTabs))
      );

      //navigate to the home page - to avoid navigation to last index and reload a case 
      setActiveTabIndex(null);
      navigateToHome();

    }
  };


  const getUserNavOptions = (user) => {
    return navOptions.filter((option) => option.roles.includes(user));
  };

  const getUserRoutes = (user) => {
    const isSuperAdminOrAdmin = user === "SuperAdmin" || user === "Admin";
    const restApi = isSuperAdminOrAdmin ? AdminApi : RadiologistApi;


    const routes = [
      {
        path: `/${rolePath}/Dashboard`,
        element: <DashboardComp />,
        allowedRoles: ["SuperAdmin", "Admin", "Radiologist"],
        includeSideNav: true,
      },
      {
        path: `/${rolePath}/Users`,
        element: <UserListComp />,
        allowedRoles: ["SuperAdmin", "Admin"],
        includeSideNav: true,
      },
      {
        path: `/${rolePath}/Sites`,
        element: <SiteListComp />,
        allowedRoles: ["SuperAdmin", "Admin", "Radiologist"],
        includeSideNav: true,
      },
      {
        path: `/${rolePath}/AdminManagement`,
        element: <AdminManagementComp />,
        allowedRoles: ["SuperAdmin"],
        includeSideNav: true,
      },
      {
        path: `/${rolePath}/Patient/:patientID/CaseId/:caseID/DICOMViewer`,
        element: <ViewerLayout addTab={addTab} />,
        allowedRoles: ["SuperAdmin", "Admin", "Radiologist"],
        includeSideNav: false,
      },
      {
        path: `/${rolePath}`,
        element: <PatientListComp addTab={addTab} />,
        allowedRoles: ["Radiologist"],
        includeSideNav: false,
      },
      {
        path: `/${rolePath}/Patient/:patientID`,
        element: <PatientComp addTab={addTab} />,
        allowedRoles: ["Radiologist"],
        includeSideNav: false,
      },
    ];

    return routes
      .filter((route) => route.allowedRoles.includes(user))
      .map((route) => ({
        ...route,
        element: React.cloneElement(route.element, { restApi, rolePath }),
      }));
  };

  const handleLogout = () => {
    authenticationService.logout();
    setOpenTabs([])
    navigate("/login");
  };

  const handleIdle = () => {
    setIsIdle(true);
    handleLogout();
  };

  const userRoutes = getUserRoutes(currentUser);

  const NavTypes = getUserNavOptions(currentUser);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openTabs, setOpenTabs] = useState(() => {
    const stored = localStorage.getItem("openTabs");
    try {
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });  

  const [activeTabIndex, setActiveTabIndex] = useState(() => {
    const stored = localStorage.getItem("activeTabIndex");
    const idx = stored != null ? Number(stored) : 0;
    return Number.isNaN(idx) ? 0 : idx;
  });


  const  navigateToPage = (page, id, examId,dicomProps) => {
    if (page === "patient") {
      navigate(`${rolePath}/Patient/${id}`);
    }
    else if (page === "case"){
      navigate(`/Radiologist/Patient/${id}/CaseId/${examId}/DICOMViewer`, { state: dicomProps || undefined,
      });
    }
    // Handle other page types similarly
  };



  const handleTabClick = (tab, i) => {
    
    setActiveTabIndex(i);
    navigateToPage(tab.page, tab.id, tab.examId,tab.dicomProps);
  };

  const navigateToHome = () => {
    navigate(
      `./${rolePath}/${
        rolePath === "SuperAdmin" || rolePath === "Admin" ? "Dashboard" : ""
      }`
    );
    setActiveTabIndex(null);
  };
  
  return (
    <div
      className={`main w-full h-full max-h-screen overflow-hidden flex p-0 relative 
          ${isLoginRoutes ? "bg-[#000000]" : "bg-[#1A1A1A]"}`}>
      {/* Background layer for login routes */}
      {isLoginRoutes && (
        <div
          id="bg-container"
          className="absolute overflow-hidden z-0 flex-column w-screen h-screen">
          <img
            src={GenesisBG}
            className="w-full h-full object-cover animate-move z-1"
            alt="Background"
          />
          <img
            src={GenesisBG}
            className="w-full h-full object-cover animate-move z-1"
            alt="Background Layer 2"
          />
          <div className="bg-customGradient absolute z-2 w-full h-full flex top-0 left-0"></div>
        </div>
      )}

      {/* Main container */}
      <div className="w-full h-full max-h-screen flex flex-col justify-start z-10 left-0 top-0 absolute">
        {/* Taskbar */}
        {!isLoginRoutes && currentUser && (
          <>
            <div className="flex w-full h-9 justify-start flex-col flex-shrink-0 bg-[blue] relative z-10">
              <div className=" bg-[#252525] flex w-full h-9 relative justify-start">
                <div className="p-[9px_0px] w-[55px] flex justify-center items-center border-r-[#484848] border-r-[1px]">
                  <SVGraphics
                    svgname={"taskBarIcon"}
                    className={"w-[20px] h-auto"}
                    onClick={handleMenu}
                  />
                </div>
                <div
                  className={`flex w-[46px] pt-[3px] justify-center items-center border-r-[#484848] border-r-[1px] ${
                    pathname !== `/${rolePath}`
                      ? "bg-transparent"
                      : "bg-[#111111]"
                  }`}>
                  <SVGraphics
                    svgname={"taskBarHome"}
                    className={"h-[24px] cursor-pointer"}
                    onClick={() => navigateToHome()}
                  />
                </div>
                {openTabs.map((tab, index) => (
                  <Tab
                    key={`tab${index}`}
                    tab={tab}
                    index={index}
                    activeTabIndex={activeTabIndex}
                    handleTabClick={handleTabClick}
                    removeTab={removeTab}
                  />
                ))}
              </div>
              <div className="bg-[#111] w-full h-[0px] flex relative">
                <IdleTimer
                  onIdle={handleIdle}
                  timeout={autoLogoutTime}
                  events={[
                    "keydown",
                    "wheel",
                    "DOMMouseScroll",
                    "mousewheel",
                    "mousedown",
                    "touchstart",
                    "touchmove",
                    "MSPointerDown",
                    "MSPointerMove",
                  ]}
                />
              </div>
            </div>
          </>
        )}

        {/* Router content and side nav */}
        <div
          className={`w-full flex flex-1 box-border ${
            isLoginRoutes ? "justify-center items-center" : ""
          } h-full max-h-full`}>
          {!isLoginRoutes && currentUser && shouldShowSideNav && (
            <SideNavigationBar
              logoutUser={handleLogout}
              rolePath={rolePath}
              NavTypes={NavTypes}
              // handleClick={() => setActiveTabIndex(null)}
              onSettingsClick={handleOpenSettings}
              onAccountClick={handleOpenAccount}
            />
          )}

          <Routes>
            {currentUser &&
              userRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              ))}
            <Route path="/verificationCode" element={<VerificationCode />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/ResetPassword" element={<ResetPassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/Register/:tokenSegment?" element={<Register />} />
            <Route path="/" element={<Login />} />
            <Route
              path="/open-access/viewer-loader"
              element={<ViewerLoader />}
            />
            <Route
              path="/open-access/dicom-viewer"
              element={<ViewerLayout restApi={RadiologistApi} />}
            />
          </Routes>
        </div>
      </div>

      {/* Tooltip version for login screen */}
      {isLoginRoutes && (
        <OverlayTrigger
          placement={"top"}
          delay={{ show: 250, hide: 750 }}
          trigger={["hover", "focus"]}
          rootClose
          overlay={
            <Tooltip id="tooltip-disabled" className={"versionToolTip"}>
              <label className={"text-[#52007E] text-sm"}>
                be-V:{beVersion?.version}
              </label>
            </Tooltip>
          }>
          <div
            className={`absolute flex text-[#52007E] text-xs ${
              !isLoginRoutes ? "ml-auto" : "ml-[115rem] mt-[57.5rem]"
            }`}>
            {Config.BuildVersion}
          </div>
        </OverlayTrigger>
      )}

      {isSettingsOpen && (
        <PopUpWindow
          isPopUpOpen={isSettingsOpen}
          formSections={formData["Settings"]}
          popupTitle="Settings"
          closePopUp={handleClosePopUp}
        />
      )}
      {isAccountOpen && (
        <PopUpWindow
          isPopUpOpen={isAccountOpen}
          formSections={formData["account_info"]}
          popupTitle="account"
          closePopUp={handleCloseAccount}
          isEditMode={true}
          editEntry={{
            first_name:
              authenticationService.currentUserValue.profile?.First_name || "",
            last_name:
              authenticationService.currentUserValue.profile?.Last_name || "",
            position:
              authenticationService.currentUserValue.profile?.Role || "",
            email: authenticationService.currentUserValue.profile?.Email || "",
            Phone_Number:
              authenticationService.currentUserValue.profile?.Phone_Number ||
              "",
          }}
          updateText="Save"
          handlePostApi={async (data) => {
            try {
              const result = await RadiologistApi.updateAccount(data);
              const updatedProfile = {
                ...authenticationService.currentUserValue.profile,
                First_name: data.first_name,
                Last_name: data.last_name,
                Phone_Number: data.phone,
              };
              authenticationService.currentUserValue.profile = updatedProfile;

              console.log("Account updated:", result);
              handleCloseAccount();
            } catch (error) {
              console.error("Failed to update account:", error);
            }
          }}
        />
      )}
    </div>
  );
}

export default MainRouters;
